import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ConfirmButtons } from '@app/shared/types';

import { E2E_ATTRIBUTES } from '@shared/types/enums/e2e-attributes.enum';
/**
 * Component: ConfirmButtonsComponent
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'confirm-buttons',
  templateUrl: './confirm-buttons.component.html',
  styleUrls: ['./confirm-buttons.component.scss'],
  standalone: false,
})
export class ConfirmButtonsComponent {
  @Output() public onResetClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onSubmitClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onOptionalClick: EventEmitter<void> =
    new EventEmitter<void>();

  private readonly buttons: ConfirmButtons = {
    reset: {
      name: '',
      disabled: false,
      e2eAttr: E2E_ATTRIBUTES.CONFIRM_BUTTONS_CANCEL,
    },
    submit: {
      name: '',
      disabled: false,
      e2eAttr: E2E_ATTRIBUTES.CONFIRM_BUTTONS_ENTER,
    },
    optional: {
      name: '',
      disabled: false,
      e2eAttr: E2E_ATTRIBUTES.CONFIRM_BUTTONS_OPTIONAL,
    },
  };

  @Input()
  public set disabledReset(value: boolean) {
    this.buttons.reset.disabled = value;
  }

  public get disabledReset(): boolean {
    return this.buttons.reset.disabled;
  }

  @Input()
  public set disabledOptional(value: boolean) {
    this.buttons.optional.disabled = value;
  }

  public get disabledOptional(): boolean {
    return this.buttons.optional.disabled;
  }

  @Input()
  public set e2eAttrOptional(value: E2E_ATTRIBUTES) {
    this.buttons.optional.e2eAttr = value;
  }

  public get e2eAttrOptional(): E2E_ATTRIBUTES {
    return this.buttons.optional.e2eAttr;
  }

  @Input()
  public set e2eAttrReset(value: E2E_ATTRIBUTES) {
    this.buttons.reset.e2eAttr = value;
  }

  public get e2eAttrReset(): E2E_ATTRIBUTES {
    return this.buttons.reset.e2eAttr;
  }

  @Input()
  public set e2eAttrSubmit(value: E2E_ATTRIBUTES) {
    this.buttons.submit.e2eAttr = value;
  }

  public get e2eAttrSubmit(): E2E_ATTRIBUTES {
    return this.buttons.submit.e2eAttr;
  }

  @Input()
  public set disabledSubmit(value: boolean) {
    this.buttons.submit.disabled = value;
  }

  public get disabledSubmit(): boolean {
    return this.buttons.submit.disabled;
  }

  @Input()
  public set reset(name: string) {
    this.buttons.reset.name = name;
  }

  public get reset(): string {
    return this.buttons.reset.name;
  }

  @Input()
  public set submit(name: string) {
    this.buttons.submit.name = name;
  }

  public get submit(): string {
    return this.buttons.submit.name;
  }

  @Input()
  public set optional(name: string) {
    this.buttons.optional.name = name;
  }

  public get optional(): string {
    return this.buttons.optional.name;
  }

  public onReset(): void {
    this.onResetClick.emit();
  }

  public onSubmit(): void {
    this.onSubmitClick.emit();
  }

  public onOptional(): void {
    this.onOptionalClick.emit();
  }
}
